import { render } from "./SaleSharedDocumentsTab.vue?vue&type=template&id=8d383190&scoped=true"
import script from "./SaleSharedDocumentsTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedDocumentsTab.vue?vue&type=script&lang=js"

import "./SaleSharedDocumentsTab.vue?vue&type=style&index=0&id=8d383190&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d383190"]])

export default __exports__